import React from 'react';
import { EAllDocumentsType } from 'reactApp/modules/allDocuments/allDocuments.types';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentTable } from 'reactApp/modules/features/features.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { isMobile } from 'reactApp/ui/Datalist/DataList.constants';
import { DataListItem } from 'reactApp/ui/DataListItem/DataListItem';
import { DataListItemType } from 'reactApp/ui/DataListItem/DataListItem.types';
import { DataListItemCreateNew, ID_NEW_ITEM } from 'reactApp/ui/DataListItemCreateNew/DataListItemCreateNew';
import { CreateNewMod } from 'reactApp/ui/DataListItemCreateNew/DataListItemCreateNew.data';

interface IProps extends Omit<DataListItemType, 'selectableKey' | 'isSelected' | 'isSelecting' | 'pos'> {
    optionIndex: number;
    handleClickCreateNew: (e) => void;
    isSharedLinks: boolean;
    selectingIdxs: string[];
    activeIndex: number | null;
    dragOverItemId: string | undefined;
    selectedCount: number;
    rootRef?: React.Ref<HTMLDivElement>;
    isPopup?: boolean;
    currentAllDocsType?: EAllDocumentsType | null;
}

export const WrapDataListItem = ({
    id,
    optionIndex,
    view,
    handleClickCreateNew,
    isSharedLinks,
    selectedIdxs,
    selectingIdxs,
    activeIndex,
    isDragging,
    dragOverItemId,
    onSelect,
    onClick,
    onContextMenu,
    selectedCount,
    storage,
    tipData,
    isFavoritesEnabled,
    onDraggingOver,
    onMouseLeave,
    register,
    unregister,
    onMouseDown,
    rootRef,
    thumbType,
    isPopup,
    isPublicDownloaded,
    currentAllDocsType,
    albumShowSelected = false,
}: IProps) => {
    if (id === ID_NEW_ITEM && optionIndex === 0) {
        let mod: CreateNewMod | undefined;
        if (storage === EStorageType.alldocuments) {
            // eslint-disable-next-line sonarjs/no-small-switch
            switch (currentAllDocsType) {
                case EAllDocumentsType.spreadsheet:
                    mod = CreateNewMod.newAllDocumentSpreadsheet;
                    break;
                default:
                    mod = CreateNewMod.newAllDocument;
                    break;
            }
        }

        return (
            /** tempexp_14729-next-line */
            <FeatureSelector
                selector={getFeatureNewContentTable}
                control={
                    <DataListItemCreateNew
                        isThumb={view === 'thumbs'}
                        onClick={handleClickCreateNew}
                        onContextMenu={handleClickCreateNew}
                        isSharedFolderOnly={isSharedLinks}
                        rootRef={rootRef}
                        storage={storage}
                        mod={mod}
                    />
                }
                variant1={
                    <DataListItemCreateNew.New
                        isThumb={view === 'thumbs'}
                        onClick={handleClickCreateNew}
                        onContextMenu={handleClickCreateNew}
                        isSharedFolderOnly={isSharedLinks}
                        rootRef={rootRef}
                        storage={storage}
                        mod={mod}
                    />
                }
            />
        );
    }

    const isSelected = selectedIdxs.includes(id);
    const isSelecting = selectingIdxs.includes(id);
    const isActive = activeIndex === optionIndex;

    return (
        <DataListItem
            id={id}
            isDragging={isDragging}
            isSelected={isSelected}
            isActive={isActive}
            isSelecting={isSelecting}
            selectedIdxs={selectedIdxs}
            isDragOver={isDragging && dragOverItemId === id && !isSelected}
            onSelect={onSelect}
            onClick={onClick}
            onContextMenu={onContextMenu}
            view={view || 'thumbs'}
            showCheckbox={selectedCount > 1}
            storage={storage || EStorageType.home}
            isMobile={isMobile}
            tipData={selectedIdxs[0] === id ? tipData : null}
            isFavoritesEnabled={isFavoritesEnabled}
            onDraggingOver={onDraggingOver}
            onMouseLeave={onMouseLeave}
            selectableKey={id}
            register={register}
            unregister={unregister}
            onMouseDown={onMouseDown}
            thumbType={thumbType}
            isPopup={isPopup}
            pos={optionIndex}
            isPublicDownloaded={isPublicDownloaded}
            albumShowSelected={albumShowSelected}
        />
    );
};
